import { Menu, MenuProps } from '@mui/material';
import { createContext, FC, ReactElement, SyntheticEvent, useRef } from 'react';
import { stopPropagation } from '../../common/common-utils';

export const MenuContext = createContext<{ closeParent: () => void }>({
  closeParent: () => {},
});

const OxMenu: FC<React.PropsWithChildren<OxMenuProps>> = props => {
  const { trigger, ...menuProps } = props;
  const triggerRef = useRef<HTMLDivElement>(null);

  return (
    <div onClick={stopPropagation}>
      <div ref={triggerRef}>{trigger}</div>
      {triggerRef.current && (
        <Menu
          {...menuProps}
          anchorEl={triggerRef.current}
          MenuListProps={{
            sx: { paddingBlock: 0 },
          }}
        />
      )}
    </div>
  );
};

interface OxMenuProps extends MenuProps {
  trigger: ReactElement<{
    onClick: (e: SyntheticEvent<HTMLButtonElement>) => void;
  }>;
  onClose?(): void;
  onOpen?(): void;
}

export default OxMenu;
